// ContractBasis/LaneGroup/Lane(Ops) API
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type LaneOpsRequests = {
    laneOpsOverview: RequestConfigFunction<Record<string, any>>
    laneOpsUpcoming: RequestConfigFunction<Record<string, any>>
    laneOpsInformation: RequestConfigFunction<{id: number}>,
    updateLaneLogistics: RequestConfigFunction<{id: number}>,
    customerTransportCreationFilterRequest: RequestConfigFunction<Record<string, any>>
}

const laneRequests: LaneOpsRequests = {
    laneOpsOverview: ({
        params = {},
    } = {}) => {
        return {
            url: 'lane/filter-request/ops-overview',
            method: 'POST',
            ...params,
        }
    },
    laneOpsUpcoming: ({
        params = {},
    } = {}) => {
        return {
            url: 'lane/filter-request/ops-upcoming',
            method: 'POST',
            ...params,
        }
    },
    laneOpsInformation: ({
        id,
    }) => {
        return {
            url: `lane/${id}/ops-information`,
            method: 'GET',
        }
    },
    updateLaneLogistics: ({
        id,
    }) => {
        return {
            method: 'PATCH',
            url: `lane/${id}/lane-logistics`,
        }
    },
    customerTransportCreationFilterRequest: ({
        params = {},
    } = {}) => {
        return {
            url: 'lane/filter-request/direct-lease-available-lanes',
            method: 'POST',
            ...params,
        }
    },
}

export default laneRequests
